import React, { useEffect } from 'react';

const PaymentFailed = () => {
  useEffect(() => {
    const redirectTimer = setTimeout(() => {
      window.location.href = 'https://app.behooked.co';
    }, 2000);
    
    return () => clearTimeout(redirectTimer);
  }, []);

  return (
    <div className="failed-container">
      <div className="failed-card">`
        <div className="failed-icon">
          <i className="crossmark">✗</i>
        </div>
        <h1>Payment Failed</h1>
        <p>We're sorry, but your payment could not be processed.</p>
        <p>This could be due to insufficient funds, an expired card, or a temporary issue with your payment provider.</p>
        <p className="redirect-message">Redirecting you to the app in 2 seconds...</p>
        <div className="action-buttons">
          <button onClick={() => window.location.replace('/')} className="home-btn">
            Return to Home
          </button>
          <button onClick={() => window.history.back()} className="retry-btn">
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
